import {
    Component, ElementRef, EventEmitter, Input, Output, ViewChild, NgZone,
    OnDestroy
} from '@angular/core';
import { Subject,  fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-collection-panel-box',
    templateUrl: './collection-panel-box.component.html',
    styleUrls: ['./collection-panel-box.component.scss']
})
export class CollectionPanelBoxComponent implements OnDestroy {
    @Input() secondary: boolean;
    @ViewChild('panel', { static: true }) panel: ElementRef;
    // @ViewChild(ScrollPanel) scrollPanel: ScrollPanel;

    private changeSubject = new Subject<Event>();
    panelStyle: any; // use an object to avoid expression change error

    minHeight = 500;

    constructor() {
    }

    get panelHeight() {

        if (!!this.panelStyle) {
            const height = this.panel.nativeElement.clientHeight - 40 + 'px';
            this.panelStyle = { ...this.panelStyle, height };
        } else {
            this.panelStyle = { width: '100%', height: `${this.minHeight}px` };
        }

        return this.panelStyle;
    }

    ngOnDestroy() {
        this.changeSubject.unsubscribe();
    }

}
